import { Box, Card, useTheme } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import { memo } from 'react'

import customConfig from 'customConfig'
import { THEME_MODE } from 'src/constants/theme'
import CardHeading from '../shared/text/CardHeading'
import AccountNumberContent from './AccountNumberContent'

const AccountNumber = ({ accountProfile: { authId }, t }) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === THEME_MODE.DARK
  return (
    <Card
      sx={{
        p: 3,
        textAlign: 'center'
      }}
    >
      <CardHeading
        title={t('exchange.account-number')}
        desc={t(customConfig.scanQrCodeDescLabel)}
      />
      <Box sx={{ my: { xs: 2, md: 3, height: 215 } }}>
        <QRCodeSVG
          value={authId}
          size={215}
          bgColor={isDarkMode ? '#121212' : '#ffffff'}
          fgColor={isDarkMode ? '#ffffff' : '#000000'}
          level='H'
        />
      </Box>
      <AccountNumberContent authId={authId} t={t} />
    </Card>
  )
}

export default memo(AccountNumber)
